import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import "./PortfolioPage.css";
import portrait from "../../assets/images/photo_2022-09-07_19-07-35.jpg";
import gateway from "../../assets/images/gw1.jpg";
import camera from "../../assets/images/Thumbnail2.jpg";
import nursing from "../../assets/images/norsing.jpg";
import pos from "../../assets/images/postSistem.png";
import Background3d from "../../components/Background3d.js/Background3d";

const copy = {
  uz: {
    nav: ["Men haqimda", "Tajriba", "Loyihalar", "Bog‘lanish"],
    heroTag: "Frontend developer · Toshkent",
    hello: "Salom, men Rustam.",
    hero: "Murakkab g‘oyalarni sodda va tezkor raqamli mahsulotlarga aylantiraman.",
    intro: "React va TypeScript yordamida biznes uchun ishonchli, qulay va chiroyli web-ilovalar yarataman.",
    work: "Loyihalarni ko‘rish",
    contact: "Bog‘lanish",
    available: "Yangi loyihalar uchun ochiq",
    aboutLabel: "01 / Men haqimda",
    aboutTitle: "Faqat chiroyli interfeys emas — ishlaydigan mahsulot yarataman.",
    aboutText: "5+ yillik tajribam davomida boshqaruv panellari, xavfsizlik tizimlari, CRM va biznes jarayonlarini avtomatlashtiruvchi platformalar ustida ishladim. Kod sifati, foydalanuvchi tajribasi va jamoaviy hamkorlikka birdek e’tibor beraman.",
    stackLabel: "Asosiy texnologiyalar",
    visualLabel: "Interaktiv texnologiyalar",
    visualTitle: "Texnologiyalarni harakatda ko‘ring.",
    visualText: "3D sahnani sichqoncha yoki barmoq bilan aylantirib ko‘rishingiz mumkin.",
    services: [
      ["01", "Frontend arxitektura", "Katta loyihalar uchun kengayadigan React arxitekturasi va qayta ishlatiluvchi komponentlar."],
      ["02", "Murakkab interfeyslar", "Dashboard, jadval, filtr, forma, xarita va role-based boshqaruv panellari."],
      ["03", "Integratsiya va real-time", "REST API, WebSocket, fayl modullari va real vaqt ma’lumotlarini ulash."]
    ],
    expLabel: "02 / Tajriba",
    expTitle: "Tajriba va yondashuv",
    jobs: [
      {
        date: "May 2024 — 07.07.2026",
        duration: "2 yil 2 oy",
        company: "O‘zbekiston Respublikasi IIV Innovatsiya loyihalari va aholiga servis X DM",
        role: "Yetakchi mutaxassis / Frontend Developer",
        points: [
          "Ichki axborot tizimlarining mijoz qismini ishlab chiqish va qo‘llab-quvvatlash.",
          "Administrator panellari, jadvallar, filtrlar, formalar va role-based interfeyslar yaratish.",
          "REST API, WebSocket va fayl modullarini integratsiya qilish.",
          "React, TypeScript, Vite, Mantine UI va React Query bilan ishlash."
        ]
      },
      {
        date: "Noyabr 2022 — hozir",
        duration: "Asosiy ish joyi",
        company: "Smart Soft Development LLC",
        role: "Frontend Developer",
        points: ["Davlat, korporativ va ichki platformalarni React, TypeScript va Vite asosida ishlab chiqish.", "Qayta ishlatiluvchi komponentlar, dashboard, KPI bo‘limlari, xaritalar va real-time funksiyalar yaratish."]
      }
    ],
    projectsLabel: "03 / Tanlangan loyihalar",
    projectsTitle: "Muammodan — ishlaydigan yechimgacha.",
    projectHint: "Loyiha tafsilotlari maxfiylik sabab qisqartirilgan.",
    contactLabel: "04 / Bog‘lanish",
    contactTitle: "Birga kuchli mahsulot yaratamizmi?",
    contactText: "Yangi loyiha, hamkorlik yoki shunchaki salomlashish uchun yozishingiz mumkin.",
    email: "Email yuborish",
    footer: "Kod, dizayn va e’tibor bilan yaratilgan",
    menu: "Menyu",
    close: "Yopish",
    facts: ["yil tajriba", "texnologiya", "o‘sish istagi"],
    openCase: "Case study ochish",
    modalLabels: ["Muammo", "Yechim", "Mening rolim", "Natija"],
    modalNote: "Maxfiylik talablari sabab ayrim texnik va biznes tafsilotlari ko‘rsatilmagan.",
    backToTop: "Yuqoriga",
    homeAria: "Bosh sahifa",
    navAria: "Asosiy navigatsiya",
    langAria: "Tilni almashtirish",
    closeAria: "Modalni yopish",
    projectDetails: "haqida batafsil",
    projectImage: "loyihasi"
  },
  en: {
    nav: ["About", "Experience", "Projects", "Contact"],
    heroTag: "Frontend developer · Tashkent",
    hello: "Hi, I’m Rustam.",
    hero: "I turn complex ideas into simple, fast digital products.",
    intro: "I build reliable, intuitive and polished web applications for businesses with React and TypeScript.",
    work: "View projects",
    contact: "Get in touch",
    available: "Available for select projects",
    aboutLabel: "01 / About",
    aboutTitle: "Not just a pretty interface — a product that works.",
    aboutText: "Over 5+ years I have built dashboards, security systems, CRMs and platforms that automate business operations. I care equally about code quality, user experience and healthy collaboration.",
    stackLabel: "Core technologies",
    visualLabel: "Interactive technologies",
    visualTitle: "See the stack in motion.",
    visualText: "Drag the 3D scene with your mouse or finger to explore it.",
    services: [
      ["01", "Frontend architecture", "Scalable React architecture and reusable components for complex products."],
      ["02", "Complex interfaces", "Dashboards, tables, filters, forms, maps and role-based admin systems."],
      ["03", "Integration & real-time", "REST APIs, WebSockets, file modules and real-time data flows."]
    ],
    expLabel: "02 / Experience",
    expTitle: "Experience & approach",
    jobs: [
      {
        date: "May 2024 — 07 Jul 2026",
        duration: "2 years 2 months",
        company: "Innovation Projects and Public Services Center, Ministry of Internal Affairs of Uzbekistan",
        role: "Lead Specialist / Frontend Developer",
        points: ["Developed and maintained client-side internal information systems.", "Built admin panels, tables, filters, forms and role-based interfaces.", "Integrated REST APIs, WebSockets and file modules.", "Worked with React, TypeScript, Vite, Mantine UI and React Query."]
      },
      {
        date: "November 2022 — present",
        duration: "Primary position",
        company: "Smart Soft Development LLC",
        role: "Frontend Developer",
        points: ["Building government, corporate and internal platforms with React, TypeScript and Vite.", "Creating reusable components, dashboards, KPI modules, maps and real-time features."]
      }
    ],
    projectsLabel: "03 / Selected work",
    projectsTitle: "From a hard problem to a working solution.",
    projectHint: "Project details are shortened due to confidentiality.",
    contactLabel: "04 / Contact",
    contactTitle: "Shall we build something great?",
    contactText: "Reach out for a new project, collaboration or simply to say hello.",
    email: "Send an email",
    footer: "Crafted with code, design and attention",
    menu: "Menu",
    close: "Close",
    facts: ["years experience", "technologies", "drive to grow"],
    openCase: "Open case study",
    modalLabels: ["Challenge", "Solution", "My role", "Outcome"],
    modalNote: "Some technical and business details are omitted due to confidentiality requirements.",
    backToTop: "Back to top",
    homeAria: "Home",
    navAria: "Main navigation",
    langAria: "Switch language",
    closeAria: "Close modal",
    projectDetails: "project details",
    projectImage: "project"
  }
};

const projects = [
  { no: "01", title: "Gateway Platform", tech: "React · TypeScript · Vite · REST API", image: gateway,
    uz: { type: "Korporativ infratuzilma", text: "Turli tarmoq segmentlari orasida trafikni xavfsiz boshqarish va monitoring qilish platformasi.", challenge: "Ko‘p sonli servislar va tarmoq segmentlari holatini bitta joyda kuzatish, sozlash va nosozliklarga tez javob berish kerak edi.", solution: "Murakkab ma’lumotlarni tushunarli dashboard, real-time holatlar, filtrlanuvchi jadvallar va boshqaruv oqimlariga aylantiruvchi modul tizimi yaratildi.", role: ["Frontend arxitekturasini tashkil qilish", "Qayta ishlatiluvchi boshqaruv komponentlari", "REST API va real-time holatlarni integratsiya qilish", "Murakkab formalar va validatsiya"], result: "Operatorlar uchun kundalik monitoring va boshqaruv jarayoni yagona, izchil interfeysga birlashtirildi." },
    en: { type: "Enterprise infrastructure", text: "A platform for securely managing and monitoring traffic across multiple network segments.", challenge: "Teams needed one place to monitor numerous services and network segments, configure them and respond quickly to incidents.", solution: "Complex data was transformed into a modular system of clear dashboards, real-time statuses, filterable tables and management workflows.", role: ["Designed the frontend architecture", "Built reusable management components", "Integrated REST APIs and real-time states", "Implemented complex forms and validation"], result: "Daily monitoring and management workflows were unified into one consistent operator interface." } },
  { no: "02", title: "Camera Management", tech: "React · TypeScript · Spring Cloud", image: camera,
    uz: { type: "Xavfsizlik va AI", text: "Kameralar, hodisalar va kuzatuv ma’lumotlarini yagona interfeysda boshqarish tizimi.", challenge: "Turli obyektlardagi kameralar, hodisalar va katta hajmdagi kuzatuv ma’lumotlarini tez topish va nazorat qilish murakkab edi.", solution: "Kamera holatlari, obyektlar, hodisalar va analitikani birlashtirgan role-based boshqaruv paneli ishlab chiqildi.", role: ["Kamera va obyektlar modullari", "Kengaytirilgan filtr va jadvallar", "Role-based interfeyslar", "API va fayl modullari integratsiyasi"], result: "Kameralarni boshqarish va hodisalarga javob berish uchun markazlashgan, qulay ish muhiti yaratildi." },
    en: { type: "Security & AI", text: "A unified system for managing cameras, incidents and surveillance data.", challenge: "Finding and controlling cameras, incidents and large volumes of surveillance data across multiple facilities was difficult.", solution: "A role-based control center combining camera statuses, facilities, incidents and analytics was developed.", role: ["Camera and facility modules", "Advanced filters and data tables", "Role-based interfaces", "API and file module integration"], result: "Camera management and incident response were brought into one centralized and efficient workspace." } },
  { no: "03", title: "Nursing Solutions", tech: "Vue · TypeScript · Node.js · MongoDB", image: nursing,
    uz: { type: "Tibbiy texnologiyalar", text: "Tibbiy xizmatlarni qulay bron qilish va operatsion jarayonlarni boshqarish platformasi.", challenge: "Bemor, hamshira va operator o‘rtasidagi xizmat buyurtmalarini tartibli va shaffof boshqarish zarur edi.", solution: "Xizmat tanlash, buyurtma berish, holatni kuzatish va operator boshqaruvini qamrab olgan responsive platforma yaratildi.", role: ["Responsive foydalanuvchi interfeysi", "Buyurtma va xizmat oqimlari", "Forma validatsiyasi", "Backend API integratsiyasi"], result: "Tibbiy xizmatni topish va buyurtma qilish jarayoni foydalanuvchi uchun sodda bosqichlarga ajratildi." },
    en: { type: "Health technology", text: "A platform for booking medical services and managing operational workflows.", challenge: "Service requests between patients, nurses and operators needed to be managed transparently and consistently.", solution: "A responsive platform covering service selection, booking, status tracking and operator management was created.", role: ["Responsive user interface", "Booking and service workflows", "Form validation", "Backend API integration"], result: "Finding and booking a medical service was simplified into a clear step-by-step experience." } },
  { no: "04", title: "POS System", tech: "React · Material UI · PostgreSQL", image: pos,
    uz: { type: "Biznes avtomatizatsiyasi", text: "Savdo, ombor va buxgalteriya jarayonlarini bitta tizimda birlashtiruvchi mahsulot.", challenge: "Savdo, ombor, xarajat va hisobotlar turli jarayonlarda yuritilgani sabab ma’lumotlarni nazorat qilish qiyin edi.", solution: "Mahsulotlar, sotuvlar, xarajatlar va hisobotlarni yagona dashboard orqali boshqaruvchi POS interfeysi ishlab chiqildi.", role: ["Dashboard va hisobot interfeyslari", "Mahsulot va ombor modullari", "API integratsiyasi", "Responsive UI va xatolarni tuzatish"], result: "Asosiy biznes ko‘rsatkichlari va kundalik operatsiyalar bitta tizimda ko‘rinadigan bo‘ldi." },
    en: { type: "Business automation", text: "A product that brings sales, inventory and accounting workflows into one system.", challenge: "Sales, stock, expenses and reporting lived in separate workflows, making business data difficult to control.", solution: "A POS interface was built to manage products, sales, expenses and reports through one dashboard.", role: ["Dashboard and reporting interfaces", "Product and inventory modules", "API integration", "Responsive UI and issue resolution"], result: "Key business metrics and daily operations became visible and manageable from one system." } }
];

const reveal = {
  hidden: { opacity: 0, y: 34 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } }
};

const UiIcon = ({ name, className = "" }) => {
  const paths = {
    upRight: <><path d="M5 19 19 5"/><path d="M9 5h10v10"/></>,
    downRight: <><path d="m5 5 14 14"/><path d="M19 9v10H9"/></>,
    up: <><path d="m6 11 6-6 6 6"/><path d="M12 5v14"/></>,
    close: <><path d="M6 6l12 12"/><path d="M18 6 6 18"/></>
  };

  return (
    <svg className={`ui-icon ${className}`.trim()} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {paths[name]}
    </svg>
  );
};

const SectionTitle = ({ label, title }) => (
  <motion.div className="section-heading" variants={reveal} initial="hidden" animate="visible">
    <p className="eyebrow">{label}</p>
    <h2>{title}</h2>
  </motion.div>
);

export default function PortfolioPage() {
  const [lang, setLang] = useState("uz");
  const [menu, setMenu] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [hoveredProject, setHoveredProject] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const cursorDotRef = useRef(null);
  const cursorRingRef = useRef(null);
  const previewRef = useRef(null);
  const t = copy[lang];
  const localizedProjects = projects.map(project => ({ ...project, ...project[lang] }));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.body.style.overflow = menu || selectedProject ? "hidden" : "";
    document.body.classList.toggle("modal-open", Boolean(selectedProject));
    return () => { document.body.style.overflow = ""; document.body.classList.remove("modal-open"); };
  }, [lang, menu, selectedProject]);

  useEffect(() => {
    const closeOnEscape = (event) => event.key === "Escape" && setSelectedProject(null);
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, []);

  useEffect(() => {
    const finePointer = window.matchMedia("(pointer: fine)").matches;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!finePointer || reducedMotion) return undefined;
    let frame;
    const move = (event) => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const x = event.clientX;
        const y = event.clientY;
        if (cursorDotRef.current) cursorDotRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        if (cursorRingRef.current) cursorRingRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        if (previewRef.current) {
          const px = Math.min(x + 28, window.innerWidth - 300);
          const py = Math.min(y + 28, window.innerHeight - 230);
          previewRef.current.style.transform = `translate3d(${Math.max(16, px)}px, ${Math.max(16, py)}px, 0)`;
        }
      });
    };
    const show = () => document.body.classList.add("cursor-active");
    const hide = () => document.body.classList.remove("cursor-active");
    window.addEventListener("mousemove", move, { passive: true });
    document.documentElement.addEventListener("mouseenter", show);
    document.documentElement.addEventListener("mouseleave", hide);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("mousemove", move);
      document.documentElement.removeEventListener("mouseenter", show);
      document.documentElement.removeEventListener("mouseleave", hide);
      document.body.classList.remove("cursor-active");
    };
  }, []);

  const links = ["about", "experience", "projects", "contact"];
  const go = (id) => {
    setMenu(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="portfolio-shell">
      <div className="noise" aria-hidden="true" />
      <div className="cursor-dot" ref={cursorDotRef} aria-hidden="true" />
      <div className={hoveredProject ? "cursor-ring is-project" : "cursor-ring"} ref={cursorRingRef} aria-hidden="true" />
      <div className={hoveredProject ? "cursor-preview is-visible" : "cursor-preview"} ref={previewRef} aria-hidden="true">
        {hoveredProject && <><img src={hoveredProject.image} alt="" /><div><span>{hoveredProject.no}</span><strong>{hoveredProject.title}</strong></div></>}
      </div>
      <header className={scrolled ? "site-header is-scrolled" : "site-header"}>
        <button className="brand" onClick={() => go("home")} aria-label={t.homeAria}>RP<span>.</span></button>
        <nav className="desktop-nav" aria-label={t.navAria}>
          {links.map((id, i) => <button key={id} onClick={() => go(id)}>{t.nav[i]}</button>)}
        </nav>
        <div className="header-actions">
          <button className="lang" onClick={() => setLang(lang === "uz" ? "en" : "uz")} aria-label={t.langAria}>{lang === "uz" ? "EN" : "UZ"}</button>
          <a className="resume" href="/resume.pdf" target="_blank" rel="noreferrer">CV <UiIcon name="upRight" /></a>
          <button className="menu-toggle" onClick={() => setMenu(!menu)} aria-expanded={menu}>{menu ? t.close : t.menu}</button>
        </div>
      </header>

      {menu && <motion.div className="mobile-menu" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        {links.map((id, i) => <button key={id} onClick={() => go(id)}><span>0{i + 1}</span>{t.nav[i]}</button>)}
      </motion.div>}

      <main>
        <section className="hero section-pad" id="home">
          <div className="hero-orb orb-one" aria-hidden="true" />
          <div className="hero-orb orb-two" aria-hidden="true" />
          <motion.div className="hero-copy" initial="hidden" animate="visible" variants={{ visible: { transition: { staggerChildren: 0.1 } } }}>
            <motion.div className="status-line" variants={reveal}><span className="status-dot" />{t.available}</motion.div>
            <motion.p className="hero-tag" variants={reveal}>{t.heroTag}</motion.p>
            <motion.h1 variants={reveal}><span>{t.hello}</span>{t.hero}</motion.h1>
            <motion.div className="hero-bottom" variants={reveal}>
              <p>{t.intro}</p>
              <div className="hero-actions">
                <button className="primary-btn" onClick={() => go("projects")}>{t.work}<UiIcon name="downRight" /></button>
                <button className="text-btn" onClick={() => go("contact")}>{t.contact}<UiIcon name="upRight" /></button>
              </div>
            </motion.div>
          </motion.div>
          <motion.div className="scroll-cue" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1 }}>SCROLL <span /></motion.div>
        </section>

        <section className="about section-pad" id="about">
          <SectionTitle label={t.aboutLabel} title={t.aboutTitle} />
          <div className="about-grid">
            <motion.div className="portrait-wrap" variants={reveal} initial="hidden" animate="visible">
              <img src={portrait} alt="Rustam Pulatov" />
              <span>Frontend<br />Developer</span>
            </motion.div>
            <motion.div className="about-copy" variants={reveal} initial="hidden" animate="visible">
              <p>{t.aboutText}</p>
              <div className="facts"><div><strong>5+</strong><span>{t.facts[0]}</span></div><div><strong>12+</strong><span>{t.facts[1]}</span></div><div><strong>∞</strong><span>{t.facts[2]}</span></div></div>
            </motion.div>
          </div>
          <motion.div className="tech-visual" variants={reveal} initial="hidden" animate="visible">
            <div className="tech-visual-copy"><p className="eyebrow">{t.visualLabel}</p><h3>{t.visualTitle}</h3><p>{t.visualText}</p></div>
            <Background3d />
          </motion.div>
          <div className="about-details">
            <motion.div className="stack-panel" variants={reveal} initial="hidden" animate="visible">
              <p className="detail-label">{t.stackLabel}</p>
              <div className="stack-cloud">
                {["JavaScript", "TypeScript", "React", "Vite", "TanStack Query", "Zustand", "Mantine UI", "Material UI", "REST API", "WebSocket", "Leaflet", "Git"].map(skill => <span key={skill}>{skill}</span>)}
              </div>
            </motion.div>
            <div className="service-list">
              {t.services.map(service => <motion.div className="service-item" key={service[0]} variants={reveal} initial="hidden" animate="visible"><span>{service[0]}</span><h3>{service[1]}</h3><p>{service[2]}</p></motion.div>)}
            </div>
          </div>
        </section>

        <section className="experience section-pad" id="experience">
          <SectionTitle label={t.expLabel} title={t.expTitle} />
          <div className="experience-list">
            {t.jobs.map((job) => <motion.article className="experience-card" key={job.company} variants={reveal} initial="hidden" animate="visible">
              <div className="exp-time">{job.date}<small>{job.duration}</small></div>
              <div><p className="company">{job.company}</p><h3>{job.role}</h3><ul>{job.points.map(point => <li key={point}>{point}</li>)}</ul></div>
              <UiIcon name="upRight" className="exp-arrow" />
            </motion.article>)}
          </div>
          <div className="skill-marquee" aria-label="Texnologiyalar"><div>REACT <i>✦</i> TYPESCRIPT <i>✦</i> NEXT.JS <i>✦</i> REDUX <i>✦</i> REST API <i>✦</i> GIT <i>✦</i> FIGMA <i>✦</i> REACT <i>✦</i> TYPESCRIPT <i>✦</i></div></div>
        </section>

        <section className="projects section-pad" id="projects">
          <SectionTitle label={t.projectsLabel} title={t.projectsTitle} />
          <div className="project-list">
            {localizedProjects.map((project) => (
              <motion.article className="project-card" key={project.title} variants={reveal} initial="hidden" animate="visible" onMouseEnter={() => setHoveredProject(project)} onMouseLeave={() => setHoveredProject(null)} onClick={() => { setHoveredProject(null); setSelectedProject(project); }} tabIndex="0" role="button" aria-label={`${project.title} ${t.projectDetails}`} onKeyDown={(event) => (event.key === "Enter" || event.key === " ") && setSelectedProject(project)}>
                <div className="project-image"><img src={project.image} alt={`${project.title} ${t.projectImage}`} loading="lazy" /><span>{project.no}</span></div>
                <div className="project-content"><p className="project-type">{project.type}</p><h3>{project.title}</h3><p>{project.text}</p><div className="project-tech">{project.tech}</div><small>{t.projectHint}</small><span className="project-open">{t.openCase}<UiIcon name="upRight" /></span></div>
              </motion.article>
            ))}
          </div>
        </section>

        <section className="contact section-pad" id="contact">
          <motion.div variants={reveal} initial="hidden" animate="visible">
            <p className="eyebrow">{t.contactLabel}</p>
            <h2>{t.contactTitle}</h2>
            <p className="contact-copy">{t.contactText}</p>
            <a className="email-link" href="mailto:rustampulatov712@gmail.com">{t.email}<UiIcon name="upRight" /></a>
          </motion.div>
          <div className="contact-links"><a href="https://www.linkedin.com/in/pulatovrustam/" target="_blank" rel="noreferrer">LinkedIn <UiIcon name="upRight" /></a><a href="https://telegram.me/rustam712/" target="_blank" rel="noreferrer">Telegram <UiIcon name="upRight" /></a><a href="https://www.instagram.com/pulatov715_/" target="_blank" rel="noreferrer">Instagram <UiIcon name="upRight" /></a></div>
        </section>
      </main>
      {selectedProject && <motion.div className="project-modal-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onMouseDown={(event) => event.target === event.currentTarget && setSelectedProject(null)}>
        <motion.section className="project-modal" role="dialog" aria-modal="true" aria-labelledby="project-modal-title" initial={{ opacity: 0, y: 45, scale: .98 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: .35, ease: [0.22, 1, 0.36, 1] }}>
          <button className="modal-close" onClick={() => setSelectedProject(null)} aria-label={t.closeAria}>{t.close}<UiIcon name="close" /></button>
          <div className="modal-hero">
            <div><p className="project-type">{selectedProject.no} / {selectedProject.type}</p><h2 id="project-modal-title">{selectedProject.title}</h2><p>{selectedProject.text}</p></div>
            <img src={selectedProject.image} alt={`${selectedProject.title} ${t.projectImage}`} />
          </div>
          <div className="modal-grid">
            <div><span className="modal-label">{t.modalLabels[0]}</span><p>{selectedProject.challenge}</p></div>
            <div><span className="modal-label">{t.modalLabels[1]}</span><p>{selectedProject.solution}</p></div>
            <div><span className="modal-label">{t.modalLabels[2]}</span><ul>{selectedProject.role.map(item => <li key={item}>{item}</li>)}</ul></div>
            <div><span className="modal-label">{t.modalLabels[3]}</span><p>{selectedProject.result}</p><div className="modal-tech">{selectedProject.tech}</div></div>
          </div>
          <p className="modal-note">{t.modalNote}</p>
        </motion.section>
      </motion.div>}
      <footer><span>© 2026 Rustam Pulatov</span><span>{t.footer}</span><button onClick={() => go("home")}>{t.backToTop}<UiIcon name="up" /></button></footer>
    </div>
  );
}
